export function LoadingIndicator({
  className,
  label = 'Wird geladen …',
}: {
  className?: string;
  label?: string;
}) {
  return (
    <div
      className={`loading-indicator ${className ?? ''}`.trim()}
      role="status"
      aria-live="polite"
    >
      <span className="loading-spinner" aria-hidden="true" />
      <span className="loading-indicator-label">{label}</span>
    </div>
  );
}
